import { BluPayApiError } from "../api/client";
import { AUTH_REASONS, errorCopy } from "./errorMessages";

function apiMessage(error) {
  return (
    errorCopy(error.reason, error.reasonValues) ||
    (typeof error.message === "string" ? error.message.trim() : "")
  );
}

/**
 * Returns copy for a PIN or password error, chosen by `reason`.
 *
 * Restrictive on purpose: anything that is not a known PIN or password
 * reason gets `fallback`, so no other server text reaches a PIN screen.
 */
export function safeAuthErrorMessage(error, fallback) {
  if (error instanceof BluPayApiError && AUTH_REASONS.has(error.reason)) {
    return apiMessage(error) || fallback;
  }

  return fallback;
}

/**
 * Returns the customer-safe message for a normalized BluPay API error:
 * the copy for its `reason`, else the API's `message`.
 *
 * getApiError() already replaces unknown or raw server responses with safe
 * text. Raw Axios errors, strings and other objects are not trusted and
 * fall back to the caller-provided message.
 */
export function safeApiErrorMessage(error, fallback) {
  if (error instanceof BluPayApiError) {
    return apiMessage(error) || fallback;
  }

  return fallback;
}
